import $ from 'jquery';
import { fabric } from '../common/fabric';
import { ui } from '../common/ui';
import { drawing } from '../common/drawing';
import { userinfo } from '../common/userinfo';

function _client() {
  // 送信用蓄積データ
  this._data = [];

  // Socket
  this._socket = undefined;

  // 送信者ユニークID
  this._sender = undefined;

  // ロード中
  this._loading = false;

  // 接続中部屋ID
  this._room_id = '';
  // 画像最大サイズ
  this.max_img_size = 15728640;
  this.max_img_size_er_msg = '15MB以下の画像を選択してください。';
  // window_height取得
  this.winHeight = $(window).height();
}

// クライアント初期化
_client.prototype.init = function() {
  var self = this;
  // 更新者のユーザーIDを設定
  self._sender = userinfo.getUserId();
  //drawing._canvas.add(drawing.backgroundPrint);
  drawing.setBackgroundPrint(null);
};

// 送信データを蓄積
_client.prototype.push = function(data) {
  var self = this;
  if (data.action == 'add' && data.objects) {
    if (data.objects[0].width == 0 && data.objects[0].height == 0) {
      //サイズが0のものは画面上から消す
      let obj = fabric.eg.getFromUuid(data.objects[0].uuid);
      drawing._canvas.remove(obj);
      drawing._canvas.requestRenderAll();
      self._data = [];
      return;
    }
    var objRemainingCount = drawing.getObjectRemainingCount();
    if (0 <= objRemainingCount && objRemainingCount <= 20) {
      // 残数が20以下の場合メッセージを表示する
      if (objRemainingCount == 0) {
        ui.showPopupMessage(
          '設置できるオブジェクト数が上限に達しました。不要なオブジェクトを削除してください。'
        );
      } else {
        ui.showPopupMessage(
          `設置できる残数が残り${objRemainingCount}個になりました`
        );
      }
    } else if (objRemainingCount < 0) {
      // 残数がない場合画面から消してメッセージを表示
      let obj = fabric.eg.getFromUuid(data.objects[0].uuid);
      drawing._canvas.remove(obj);
      drawing._canvas.requestRenderAll();
      self._data = [];
      ui.showPopupMessage(
        '設置できるオブジェクト数が上限に達しました。不要なオブジェクトを削除してください。'
      );
      return;
    }
  }
  // オブジェクト数表示(画像表示用にsetTimeoutを使用)
  setTimeout(function() {
    drawing.updateObjectCount();
  }, 100);
};

// 蓄積データを送信
_client.prototype.flush = function() {
  // 処理なし
};

// 受信処理
_client.prototype.update = function() {
  // 処理なし
};

// 部屋変更
_client.prototype.changeRoom = function() {
  // 処理なし
};

// 部屋へ接続
_client.prototype.joinRoom = function() {
  // 処理なし
};

// 部屋取得
_client.prototype.getRoomId = function() {
  var self = this;
  return self._room_id;
};

// 印刷範囲更新
_client.prototype.flushPrintRange = function() {
  // 処理なし
};

// 印刷範囲更新
_client.prototype.getPdf = function() {
  // 処理なし
};

// SingnalR周知用
_client.prototype.dataPublish = function() {
  // 処理なし
};

// debug用
_client.prototype.debug = function() {
  // console.log(str);
};
_client.prototype.getHeaderHeight = function() {
  return 134;
};
// relative point base on backgroundPrint and viewportTransform
_client.prototype.getRelativePoint = function() {
  const x =
    (window.innerWidth - drawing.backgroundPrint.width) / 2 -
    drawing.backgroundPrint.left -
    drawing._canvas.viewportTransform[4];
  const y =
    (window.innerHeight -
      this.getHeaderHeight() -
      drawing.backgroundPrint.height) /
      2 -
    drawing.backgroundPrint.top -
    drawing._canvas.viewportTransform[5];
  return { x, y };
};

export const client_keyplan = new _client();



// WEBPACK FOOTER //
// ./src/canvas/keyPlan/client_v2_keyplan.js